import { Route, Switch } from "react-router-dom";

import BrandPromotionsPage from "@faire/prototype-playground/workspace/as/brand-promotions";
import PromoInHeaderUnderTotalPage from "@faire/prototype-playground/workspace/as/promo-in-header-under-total";

export function AmmadShaikhRoutes() {
  return (
    <Switch>
      <Route path="/as/brand-promotions" component={BrandPromotionsPage} />
      <Route path="/as/promo-in-header-under-total" component={PromoInHeaderUnderTotalPage} />
    </Switch>
  );
}

export const slug = "as";
